import React from 'react'
import { csv } from 'd3-fetch'
import { FormattedMessage } from 'react-intl'
import { commonDescriptors } from '../../locale/messages'
import { useEnv } from '../../lib/env'
import Needle from '../BallotResultGauge/internal/Needle'
import { BallotProjectionSparkline } from '../BallotProjectionSparkline'
import ScaleImage from './images/scaleImage'
import ScaleImageInactive from './images/scaleImageInactive'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { createGlobalStyle } from 'styled-components'
import { caseBallotState } from '@/domain'

const isMobile = browserCheck.isMobile
const csvWatcher = {}

class Gauge extends React.Component {
  constructor(props) {
    super(props)

    // console.log('###', this.props.summary.name.de.toUpperCase())
    // console.log('## props', this.props)
    const ballotID = this.props.summary.externalSource.vorlagenId.toString()
    // console.log('ballotID:', ballotID)
    // console.log('ballotState:', this.props.ballotState)
    // console.log('outcome:', this.props.outcome)
    // console.log('summary:', this.props.summary)
    // console.log('embedLanguage:', this.props.embedLanguage)
    this.fetchLeewasData = this.fetchLeewasData.bind(this)

    if (this.props.summary.state.ballotState.finalResult === undefined) {
      this.state = {
        isActive: false,
        isFinished: false,
        estimate: 50,
        spread: -1,
        label: '',
        communitiesCounted: 0,
        timeUpdated: '',
        ballotID: ballotID,
        staendeVotes: -1,
        staendeOverride: false,
        projectionData: [],
        projectionLanguage: this.props.embedLanguage ? this.props.embedLanguage : this.props.projectionLanguage,
      }
      this.fetchLeewasData()
      setInterval(() => {
        this.fetchLeewasData()
      }, 30000)
    } else {
      const estimate = this.props.summary.state.ballotState.finalResult.votes.yea.percent / 100
      // console.log('estimate:',estimate)
      this.state = {
        isActive: true,
        isFinished: true,
        estimate: estimate,
        spread: 0,
        label: '',
        communitiesCounted: 100,
        timeUpdated: '',
        ballotID: ballotID,
        staendeVotes: this.calculateStaendeVotes(),
        // staendeOverride: false,
        // projectionData: [],
        projectionLanguage: this.props.embedLanguage ? this.props.embedLanguage : this.props.projectionLanguage,
      }
      // fetch projection data once to feed the sparkline
      this.fetchLeewasData()
    }
  }

  componentDidMount() {
    // console.log('### componentDidMount')
  }

  componentDidUpdate() {
    const vorlagenId = this.props.summary.externalSource.vorlagenId.toString()
    // console.log('## ballotID',this.state.ballotID)
    // console.log('## vorlagenId',vorlagenId)
    if (this.state.ballotID !== vorlagenId) {
      // console.log('## RESET ##')
      this.setState({ ballotID: vorlagenId })

      if (this.props.summary.state.ballotState.finalResult === undefined) {
        // console.log('## csvWatcher:', csvWatcher)
        clearInterval(csvWatcher[this.state.ballotID])
        delete csvWatcher[this.state.ballotID]
        this.setState(
          {
            estimate: 50,
            isActive: true,
            isFinished: false,
          },
          function () {
            this.fetchLeewasData()
            const csvInterval = setInterval(() => {
              this.fetchLeewasData()
            }, 30000)
            csvWatcher[vorlagenId] = csvInterval
          },
        )
      } else {
        const estimate = this.props.summary.state.ballotState.finalResult.votes.yea.percent / 100
        this.setState({ estimate: estimate })
      }
    }
  }

  fetchLeewasData() {
    // console.log('fetchLeewasData')
    const dt = new Date()
    csv(
      'https://tamedia-abstimmungszentrale-hochrechnung.storage.googleapis.com/' +
        this.state.ballotID +
        '.csv?' +
        dt.getTime(),
    ).then((data) => {
      const last = data[data.length - 1]
      if (last) {
        // Overwrite the Estimate of the last entry with what we have in the Firestore database.
        // This ensures that we always show a consistent number (even if a minute stale).
        last.Estimate = caseBallotState({
          pre: last.Estimate,
          inProgress: last.Estimate,
          trend: ({}) => last.Estimate,
          projection: ({ projection }) => projection / 100,
          finalResult: ({ finalResult }) => finalResult.votes.yea.percent / 100,
        })(this.props.summary.state.ballotState)
      }

      this.setState({ leewasData: data }, function () {
        // console.log('leewasData', this.state.leewasData)
        let projectionData = this.state.leewasData.filter((row) => row.Estimate !== '')
        projectionData = projectionData.filter((row) => row.BfS_number === this.state.ballotID && row.active === '1')
        // console.log('projectionData', projectionData)
        this.setState({ projectionData: projectionData }, function () {
          // console.log('this.state.projectionData', this.state.projectionData)
        })
        const lastRow = this.state.leewasData[this.state.leewasData.length - 1]
        // console.log('lastRow: ', lastRow)
        const isActive = !!parseInt(lastRow.active)
        const timeUpdated = lastRow.Time.substring(0, lastRow.Time.length - 3)
        this.setState({ timeUpdated: timeUpdated })

        if (this.props.summary.state.ballotState.finalResult !== undefined) {
          // console.log('## show finalResult data')
          const estimate = this.props.summary.state.ballotState.finalResult.votes.yea.percent / 100
          this.setState({
            isActive: true,
            isFinished: true,
            estimate: estimate,
            spread: 0,
            label: '',
            communitiesCounted: 100,
            //timeUpdated: '',
            //ballotID: ballotID,
            staendeVotes: this.calculateStaendeVotes(),
            // staendeOverride: false,
            // projectionData: [],
            // csvWatcher: null,
            //projectionLanguage: this.props.embedLanguage ? this.props.embedLanguage : this.props.projectionLanguage
          })
        } else if (!(this.state.isFinished && this.state.isActive)) {
          // console.log('## show leewas data')
          this.setState({ isActive: isActive }, function () {
            if (this.state.isActive) {
              const estimate = lastRow.Estimate
              this.setState({ estimate: estimate })
              const isFinished = lastRow.Share_counted
              if (isFinished == '1') {
                this.setState({ isFinished: true })
              } else {
                this.setState({ isFinished: false })
              }
              const spread = lastRow.upper_bound - lastRow.lower_bound
              this.setState({ spread: spread })
              const communitiesCounted = Math.round(lastRow.Share_counted * 100)
              this.setState({ communitiesCounted: communitiesCounted })
              let label = 'not set'
              this.state.projectionLanguage === 'fr' && lastRow.label_fr
                ? (label = lastRow.label_fr)
                : this.state.projectionLanguage === 'it' && lastRow.label_it
                  ? (label = lastRow.label_it)
                  : (label = lastRow.label)
              this.setState({ label: label })
              const staendeVotes = +lastRow.Standesstimmen
              this.setState({ staendeVotes: staendeVotes }, function () {
                this.setState({
                  staendeOverride:
                    this.state.staendeVotes <= 11.5 &&
                    this.state.estimate > 50 &&
                    this.state.communitiesCounted === 100 &&
                    this.state.staendeVotes != -1
                      ? true
                      : false,
                })
              })
            } else {
              this.setState({ estimate: 50 })
            }
          })
        }
      })
    })
  }

  calculateSpreadPercentage(spread) {
    let spreadPercentage = Math.round(spread * 10) / 10
    spreadPercentage = spreadPercentage.toString().split('.').join(',')
    return spreadPercentage + '%'
  }

  calculateStaendeVotes() {
    // console.log('## calculateStaendeVotes')
    // console.log('this.props.summary.cantons',this.props.summary.cantons)
    // console.log('this.props.summary.majorityOfCantonsRequired',this.props.summary.majorityOfCantonsRequired)
    let staendeVotes = -1
    const weights = [
      { cantonId: 'ZH', weight: 1 },
      { cantonId: 'BE', weight: 1 },
      { cantonId: 'LU', weight: 1 },
      { cantonId: 'UR', weight: 1 },
      { cantonId: 'SZ', weight: 1 },
      { cantonId: 'OW', weight: 0.5 },
      { cantonId: 'NW', weight: 0.5 },
      { cantonId: 'GL', weight: 1 },
      { cantonId: 'ZG', weight: 1 },
      { cantonId: 'FR', weight: 1 },
      { cantonId: 'SO', weight: 1 },
      { cantonId: 'BS', weight: 0.5 },
      { cantonId: 'BL', weight: 0.5 },
      { cantonId: 'SH', weight: 1 },
      { cantonId: 'AR', weight: 0.5 },
      { cantonId: 'AI', weight: 0.5 },
      { cantonId: 'SG', weight: 1 },
      { cantonId: 'GR', weight: 1 },
      { cantonId: 'AG', weight: 1 },
      { cantonId: 'TG', weight: 1 },
      { cantonId: 'TI', weight: 1 },
      { cantonId: 'VD', weight: 1 },
      { cantonId: 'VS', weight: 1 },
      { cantonId: 'NE', weight: 1 },
      { cantonId: 'GE', weight: 1 },
      { cantonId: 'JU', weight: 1 },
    ]

    if (this.props.summary.majorityOfCantonsRequired) {
      const accepters = this.props.summary.cantons.filter(function (canton) {
        if (canton.state.finalResult !== undefined) {
          return canton.state.finalResult.votes.yea.percent > canton.state.finalResult.votes.nay.percent
        }
      })
      //console.log('## accepters:', accepters)

      const result = accepters.map((canton) => weights.find((o) => o.cantonId === canton.id).weight)
      //console.log('## result:', result)
      if (result.length > 0) {
        staendeVotes = result.reduce(function (accumulator, current) {
          return accumulator + current
        })
      } else {
        staendeVotes = 0
      }
    } else {
      staendeVotes = -1
    }
    //console.log('## finalResult staendeVotes:', staendeVotes)

    // is there a override by the staende?
    if (this.state !== undefined) {
      // console.log('## OVERRIDE estimate?',this.state.estimate)
      if (
        staendeVotes <= 11.5 &&
        this.state.estimate > 50 &&
        this.state.communitiesCounted === 100 &&
        staendeVotes != -1
      ) {
        this.setState({ staendeOverride: true })
      }
    }

    return staendeVotes
  }

  getDynamicElements() {
    const detailState = this.props.hideDetails ? 'small' : 'normal'
    const projectionState = this.state.isActive ? 'active' : 'inactive'
    const result =
      this.state.estimate < 50 || this.state.staendeOverride ? 'nay' : this.state.estimate > 50 ? 'yea' : 'tie'
    const overrideState = this.state.staendeOverride ? 'override' : 'nooverride'
    let resultPercentage = parseFloat(this.state.estimate)
    if (this.state.estimate < 50) {
      resultPercentage = 100 - this.state.estimate
    }
    resultPercentage = Math.round(resultPercentage * 10) / 10
    resultPercentage = resultPercentage.toString().split('.').join(',')
    const resultText = this.state.isActive ? (
      this.state.staendeOverride ? (
        <FormattedMessage id="mStndmhrGschtrt" defaultMessage="Ständemehr nicht erreicht" />
      ) : this.state.estimate > 50 ? (
        <FormattedMessage {...commonDescriptors.yea} />
      ) : this.state.estimate < 50 ? (
        <FormattedMessage {...commonDescriptors.nay} />
      ) : (
        <FormattedMessage id="KnTrnd" defaultMessage="Kein Trend" />
      )
    ) : (
      <FormattedMessage id="NchknHchrchnng" defaultMessage="Noch keine Prognose" />
    )

    const spreadPercentage = this.calculateSpreadPercentage(this.state.spread / 2)
    const staendeYea = this.state.staendeVotes
    const staendeNay = 23 - this.state.staendeVotes
    const communitiesCounted = this.state.communitiesCounted
    const ScaleImg = this.state.isActive ? ScaleImage : ScaleImageInactive
    return {
      detailState: detailState,
      projectionState: projectionState,
      result: result,
      resultText: resultText,
      overrideState: overrideState,
      resultPercentage: resultPercentage,
      spreadPercentage: spreadPercentage,
      staendeYea: staendeYea,
      staendeNay: staendeNay,
      communitiesCounted: communitiesCounted,
      ScaleImg: ScaleImg,
    }
  }

  render() {
    // console.log('### RENDER')
    // console.log('this.state.estimate:',this.state.estimate)
    // console.log(commonDescriptors)

    const {
      detailState,
      projectionState,
      result,
      resultText,
      overrideState,
      resultPercentage,
      spreadPercentage,
      staendeYea,
      staendeNay,
      communitiesCounted,
      ScaleImg,
    } = this.getDynamicElements(this.state)

    return (
      <div className={`gauge ${detailState}`}>
        <Style />

        <div className="padder">
          <div className={`vis-wrapper ${detailState} ${overrideState}`}>
            {(!this.props.hideDetails || !isMobile) && (
              <div className={`spread-txt ${detailState}`}>
                {this.state.isActive && this.state.communitiesCounted < 100 ? (
                  <nobr>&plusmn; {spreadPercentage}</nobr>
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            )}
            <div className={`scale-wrapper ${detailState}`}>
              {/* <img src={scaleImg} className="scale" /> */}
              <ScaleImg />
              {this.state.isActive && (
                <Needle
                  isFinished={this.state.isFinished}
                  estimate={this.state.estimate}
                  spread={this.state.spread}
                  hideDetails={this.props.hideDetails}
                />
              )}
            </div>
            {this.props.hideDetails && isMobile && (
              <div className={`spread-txt ${detailState}`}>
                {this.state.isActive && this.state.communitiesCounted < 100 ? (
                  <nobr>&plusmn; {spreadPercentage}</nobr>
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            )}
          </div>
        </div>
        <div className={`projection ${projectionState}`}>
          <div className={`result ${result} ${projectionState} ${detailState} ${overrideState}`}>
            {this.state.isActive && !this.state.staendeOverride && (
              <span className="estimate">{resultPercentage}% </span>
            )}{' '}
            {resultText}
          </div>
          {!this.props.hideDetails && this.state.staendeVotes >= 0 && (
            <div className="staende">
              <span className="count">
                <FormattedMessage id="StndsStmmn" defaultMessage="Standesstimmen" />:{' '}
                <span className="nay">
                  {staendeNay} <FormattedMessage {...commonDescriptors.nay} />,
                </span>{' '}
                <span className="yea">
                  {staendeYea} <FormattedMessage {...commonDescriptors.yea} />
                </span>
              </span>
            </div>
          )}
          {this.state.isActive && !this.props.hideDetails && (
            <div className="status">
              {communitiesCounted}% <FormattedMessage id="drGmndn" defaultMessage="der Gemeinden" />
              {this.state.timeUpdated && (
                <span>
                  ,{' '}
                  <TimeLocale timeUpdated={this.state.timeUpdated} projectionLanguage={this.state.projectionLanguage} />
                </span>
              )}
            </div>
          )}
          {!this.props.hideDetails && this.state.staendeVotes < 0 && (
            <div className="staende">
              <span className="count">&nbsp;</span>
            </div>
          )}
          {this.state.isActive && !this.props.hideDetails && this.state.projectionData && (
            <div className={`spark-wrapper ${projectionState}`}>
              <BallotProjectionSparkline
                csvData={this.state.projectionData}
                lineColors={{
                  approved: '#378EBD',
                  declined: '#D3343F',
                  tie: '#7D7D7D',
                }}
                projectionLanguage={this.state.projectionLanguage}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

const LangWrapper = (props) => {
  const { intl } = useEnv()
  const lang = intl.locale.split('-CH').shift()
  return <Gauge {...props} projectionLanguage={lang} />
}

const TimeLocale = (props) => {
  const outputTime = props.projectionLanguage == 'fr' ? props.timeUpdated.replace(':', 'h') : props.timeUpdated
  return (
    <>
      {outputTime} {!props.projectionLanguage && <FormattedMessage id="tmhrra" defaultMessage="Uhr" />}
    </>
  )
}

export default LangWrapper

const Style = createGlobalStyle`
  .gauge {
    position: relative;
    width: 100%;
    margin-top: 0.6rem;

    .spread-txt {
      font-family: var(--font-sans-serif);
      color: var(--text-color);
      font-size: 1.1rem;
      line-height: 1.3;
      font-weight: 400;
      width: 100%;
      text-align: center;
    }
    .spread-txt.small {
      font-size: 0.7rem;
      margin-top: 3px;
      @media screen and (min-width: 600px) and (max-width: 1024px) {
        font-size: 12px;
        margin-bottom: 5px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 12px;
        margin-bottom: 4px;
      }
    }
    .vis-wrapper.small {
      width: 40px;
      float: right;
      position: relative;
      @media screen and (min-width: 600px) and (max-width: 1024px) {
        width: 84px;
      }
      @media screen and (min-width: 1025px) {
        width: 130px;
      }
    }
    .vis-wrapper.small.override {
      @media screen and (max-width: 600px) {
        display: none;
      }
    }
    .scale-wrapper {
      padding-bottom: 57.11%; // aspect ratio 436x249px

      img.scale {
        width: 100%;
        height: auto;
        position: absolute;
      }

      svg.scale {
        width: 100%;
        height: auto;
        position: absolute;
        .st0{fill:var(--site-background);}
      }
      svg.scale.active{

        .st1{fill:#69A8CC;}
        .st2{fill:#378DBD;}
        .st3{fill:#DE666F;}
        .st4{fill:#D2343F;}
        .st5{fill:#E9999F;}
        .st6{fill:#F3CACE;}
        .st7{fill:#CCE1EC;}
        .st8{fill:#9AC4DD;}
      }
      svg.scale.inactive{
        .st1{fill:#D4D4D4;}
        .st2{fill:#C4C4C4;}
        .st3{fill:#E2E2E2;}
        .st4{fill:#E9E9E9;}
      }
    }
    .projection {
      font-family: var(--font-sans-serif);
      width: 100%;
      text-align: center;
      font-size: 0.94rem; // 15px;
      line-height: 1.35rem; // 21px;
      @media screen and (max-width: 600px) {
        font-size: 0.85rem;
        line-height: 1.25rem;
      }

      .result {
        font-size: 1.5rem; // 24px;
        line-height: 1.7rem; // 27px;
        font-weight: 600;
        color: var(--gray-color);
        margin: 0.7rem 0;
        @media screen and (max-width: 600px) {
          font-size: 1.4rem;
          line-height: 1.6rem;
          margin: 0.5rem 0;
        }
      }
      .result.small {
        font-family: var(--font-sans-serif);
        font-size: 1.25rem;
        text-align: left;
        position: relative;
        top: 0;
        left: 0;
        margin: 0;
      }
      .result.small.inactive {
        font-family: var(--font-sans-serif);
        font-weight: 400;
        font-size: 0.85rem;
        line-height: 1rem;
      }
      .result.small.nay.override {
        font-family: var(--font-sans-serif);
        font-size: 1.1rem;
        line-height: 1.25rem;
      }
      .result.yea,
      span.yea {
        color: var(--blue-main);
      }
      .result.nay,
      span.nay {
        color: var(--red-main);
      }
      .status {
        color: var(--gray-color);
      }
      .staende {
        span.yea,
        span.nay {
          font-weight: 600;
        }
      }
    }
    .spark-wrapper {
      margin-top: 0.8em;
    }
    .inactive {
      color: var(--color-gray-gray-3) !important;
    }
  }

  .gauge.normal .padder {
    @media screen and (min-width: 375px) and (max-width: 600px) {
      width: 85%;
      position: relative;
      margin: 0 auto;
    }
  }
  .gauge.small {
    @media screen and (max-width: 600px) {
      max-height: 39px;
      overflow: visible;
    }
    overflow: hidden;
    margin-top: 0;
  }
`
